<template>
    <v-select
            v-model="item"
            dir="rtl"
            label="Title"
            :reduce="x => x.Id"
            :options="items"
            :loading="loading"
            @open="onOpen"
            :clearable="clearable"
            :disabled="disabled"
    >
    <span
            slot="no-options"
            @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
        <template #spinner>
            <div class="demo-inline-spacing">
                <b-spinner
                        v-if="loading"
                        class="m-0"
                        small
                        variant="secondary"
                />
            </div>
        </template>
    </v-select>
</template>

<script>

import vSelect from 'vue-select'

export default {
    name: 'UserRole',
    components: {
        vSelect,
    },
    props: {
        value: {
            type: Number,
            default: null,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            items: [],
            val: this.value,
            loading: false,
        }
    },
    computed: {
        item: {
            get() {
                if (this.value) {
                    this.get()
                }
                return this.val
            },
            set(newValue) {
                this.$emit('input', newValue)
                this.val = newValue
            },
        },
    },
    watch: {
        value(v) {
            this.val = v
        },
    },
    methods: {
        get() {
            if (this.items.length === 0) {
                this.loading = true
                this.$http.post(
                    this.$api.userrole.getall, {},
                )
                    .then(res => {
                        this.items = res.data
                        this.loading = false
                    })
            }
        },
        onOpen() {
            this.get()
        },
    },
}
</script>
